import { z } from 'zod';
import { credentialsSchema } from './credentials.schema';


export const signupCredentialsSchema = credentialsSchema.extend({
    terms: z.boolean().refine(val => val, { message: 'You must accept the terms' }),
});

export type SignupCredentialsFormData = z.infer<typeof signupCredentialsSchema>;
